import { useReframe, dispatch } from 'nike-re-framejs';
import React, { useEffect } from 'react';

import i18n from '../../common/i18n';
import { trackEvent } from '../../analytics/gtm';
import {
    fetchGrid,
    gridConfig$,
    gridEnabledOriginal$,
    gridError$,
    sendGridForm,
    setGridEnabled,
    setGridValue
} from './h&s';
import { Switch } from '../forms/Switch';
import Input from '../forms/Input';
import { Button } from '../button/Button';

const PATH = {
    GRID_ENABLED: ['gridEnabled'],
    GRID_POSITION: ['gridPosition'],
    GRID_CODE: ['gridCode']
};

function GridForm() {
    const { derefSub } = useReframe();
    const grid = derefSub(gridConfig$);
    const gridEnabledOriginal = derefSub(gridEnabledOriginal$);
    useEffect(fetchGrid, []);
    return <GridFormIn key={grid.get('time')} grid={grid} gridEnabledOriginal={gridEnabledOriginal} />;
}

function setGridCode(e) {
    const gridCode = e.target.value;
    const gridCodeNormalize = gridCode.trim().slice(0, 3);
    dispatch(setGridValue(gridCodeNormalize));
}

function GridFormIn({ grid, gridEnabledOriginal }) {
    function onSubmit() {
        trackEvent('Moj profil', 'Odoslat zmenu udajov - Grid');
        sendGridForm(grid);
    }
    const { derefSub } = useReframe();
    const gridError = derefSub(gridError$);
    const gridEnabled = grid.get('gridEnabled');
    return grid.get('gridExists') ? (
        <>
            <div className="flex justify-between mt-20 fs-16 c-black-100">
                <div>{i18n('nui.profileSettings.useGridCardSwitch')}</div>
                <Switch
                    active={gridEnabled}
                    onClick={() => dispatch(setGridEnabled(!gridEnabled))}
                    dataAtid="toggle-switch-grid"
                />
            </div>
            {gridEnabledOriginal !== gridEnabled && (
                <div className="pt-20 grid-enabled">
                    <Input
                        className="text-bold fs-14 pb-5"
                        value={grid.getIn(PATH.GRID_CODE) || '' /*@ts-ignore*/}
                        onChange={setGridCode}
                        label={i18n('nui.profileSettings.useGridCardPosition') + ' ' + grid.get('gridPosition')}
                        hasError={!!gridError}
                        errorText={gridErrorMessage(gridError)}
                    />
                    <Button
                        onClick={onSubmit}
                        primary
                        className="nui-button profile-settings-narrow-button-temp"
                        label={i18n('nui.button.submit')}
                        dataAtid="send-document-submit"
                        disabled={!grid.getIn(PATH.GRID_CODE)}
                    />
                </div>
            )}
        </>
    ) : (
        <p>{i18n('nui.profileSettings.gridDoesNotExist')}</p>
    );
}

const gridErrorMessage = error => {
    switch (error) {
        case 'grid.blocked':
            return i18n('nui.profileSettings.useGrid.blocked');
        case 'grid.wrong':
            return i18n('nui.profileSettings.useGrid.wrong');
        default:
            return '';
    }
};

export default GridForm;
